var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6v20h26V6H3zm2 2h22v16H5V8zm2 2v4h2v-2h2v-2H7zm14 0v2h2v2h2v-4h-4zM7 18v4h4v-2H9v-2H7zm16 0v2h-2v2h4v-4h-2z"
  })));
};
export default SvgExitFullscreen;